import { useHistory } from 'react-router-dom';
import { useState, useContext } from 'react';
import {Container, Form} from 'reactstrap';
import { useMutation } from '@apollo/client';
import {Link} from 'react-router-dom';
import query from '../../query';
import InputText from '../../components/inputText/InputText';
import Button from '../../components/button/Button';
import Loader from '../../components/loader/Loader';
import Logo from '../../components/logo/Logo';
import AuthContext from '../../context/authContext';
import { clearStoredMfaMetadata } from './MfaUtils';

export default function ShowMultifactorAuthentication() {
  const history = useHistory();
  const [cellNumber, setCellNumber] = useState('');
  const userId = parseInt(localStorage.getItem('user_auth_id'), 10);

  const [sendMfaCode, { loading, error }] = useMutation(query.sendMfaCode, {
    errorPolicy: 'all'
  });

  const handleSubmit = async (e, communicationMethod = 'sms') => {
    e.preventDefault();
    const variables = {
      userId,
      cellPhoneNumber: cellNumber,
      communicationMethod,
    };
    localStorage.setItem('communicationMethodMfa', communicationMethod);
    try {
      const { data } = await sendMfaCode({ variables });
      if (data?.sendMfaCode?.success) {
        history.push('/verifyIdentity');
      }
    } catch (err) {
      console.error('[handleSubmit] Error sending MFA code:', err);
    }
  };

  const { logout } = useContext(AuthContext);
  const logOut = (e) => {
    e.preventDefault();
    localStorage.removeItem('loan_id');
    localStorage.removeItem('user_auth_data');
    clearStoredMfaMetadata();
    logout();
    history.push('/');
  };

  return (
    <div>
      <Container>
        <Form
          onSubmit={(e) => handleSubmit(e, 'sms')}
          className="py-1 py-lg-5 align-element-center"
        >
          <div className="col-lg-4 col-12 col-md-7 m-auto text-center">
            <Logo />
            {loading && <Loader />}
            <h2 className="mb-3 mt-3">
              <b>Verify Your Identity</b>
            </h2>
            <p className="text-muted mb-4">
              <b>Please provide your phone number for Multi-Factor Authentication (MFA).</b>
            </p>
            <InputText
              type="text"
              name="cell_number"
              id="cell_number"
              placeholder="Enter your cell phone number"
              onChange={(e) => setCellNumber(e.target.value)}
              value={cellNumber}
              required={true}
              style={{ textAlign: 'center' }}
            />
            {error && <p className="text-danger mt-2">{error.message}</p>}
            <div className="mt-4">
              <Button
                type="submit"
                title={loading ? 'Sending...' : 'Send'}
                disabled={!cellNumber.trim() || loading}
              />
            </div>
            <div className="row justify-content-between mt-4">
              <div className="col-6 text-left">
                <Link to="/" onClick={logOut} className="text-muted">
                  <i>
                    <u>Return to Homepage</u>
                  </i>
                </Link>
              </div>
              <div className="col-6 text-right">
                <Link to="/" onClick={(e) => handleSubmit(e, 'email')} className="text-muted">
                  <i>
                    <u>
                      Use Another Method
                    </u>
                  </i>
                </Link>
              </div>
            </div>
          </div>
        </Form>
      </Container>
    </div>
  );
}
